module.exports = __webpack_public_path__ + "img/racecourse-durbanville-turf-2000.9cbc14de.svg";